import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import { Box } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import Datepicker from '../../../common/datePicker'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { dispatchView, reportView } from './constant'
import StationWiseDefaultView from './StationWiseDefaultView'
import StationWiseMemoView from './StationWiseMemoView'
import VehicleWiseDefaultView from './VehicleWiseDefaultView'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  getDispatchRegisterReportFilter,
  getDispatchRegisterReportTableData,
  getDispatchRegisterReportVehicleWiseTableData,
  GetDispatchRegistorMemoTableData,
} from '../../../../store/reports/reports_action'
import { updateAlertError } from '../../../../store/common/common_action'
import { removeDuplicatesFromArray } from '../../../common/helper'
import { useAtom } from 'jotai'
import { fetchDispatchRegisterSummary } from '../../../common/jotaiState/dispatchRegisterReport'
import MemoSummary from './memoSummary'

const DispatchRegister = (props) => {
  // const dispatch = useDispatch()
  // const state = useSelector((state) => state)
  const paymentModesWithAll = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Paid' },
    { id: 2, name: 'ToPay' },
  ]
  // const { data, getDispatchRegisterReportFilter, getDispatchRegisterReportTableData, GetDispatchRegistorMemoTableData,getDispatchRegisterReportVehicleWiseTableData } = props
  // const { common, reports, } = data
  const {
    data: { common, reports },
    getDispatchRegisterReportFilter,
    getDispatchRegisterReportTableData,
    getDispatchRegisterReportVehicleWiseTableData,
    updateAlertError,
    GetDispatchRegistorMemoTableData,
  } = props
  const { loginData,companySettings } = common
  const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
  const { dispatchResisterFilterData, dispatchResisterTableData, dispatchResisterTableVehicleWiseData, dispatchResisterMemoTableData } =
    reports
  const [selDispatchView, setSelDispatchView] = useState(dispatchView[0])
  const [showReport, setShowReport] = useState(false)
  const [selReportView, setSelReportView] = useState(reportView[0])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [sourceCity, setSourceCity] = useState([])
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceBranch, setSourceBranch] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [destinationCity, setDestinationCity] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationBranch, setDestinationBranch] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [vehicleNoData, setVehicleNoData] = useState([])
  const [selVehicleNo, setSelVehicleNo] = useState('')
  const [paymentType, setPaymentType] = useState(paymentModesWithAll?.[0])
  const [tableDataForMemoFirst, setTableDataForMemoFirst] = useState([])
  const [tableDataForMemoSecond, setTableDataForMemoSecond] = useState([])
  const [tableDataForMemoThird, setTableDataForMemoThird] = useState([])
  const [, fetchMemoSummary] = useAtom(fetchDispatchRegisterSummary)
  const reportName = 'Dispatch Register'
  const { intCompanyID = 0 } = { ...loginData }
  const reportViewList = [...reportView, ...(intCompanyID === 1 ? [{ id: 2, name: 'Memo Summary' }] : [])]
  const HeaderData = {
    FromDate: moment(fromDate).format('DD-MM-YYYY'),
    ToDate: moment(toDate).format('DD-MM-YYYY'),
    FromCity: selSourceCity?.FromCity,
    FromBranch: selSourceBranch?.FromBranch,
    DispatchView: selDispatchView?.name,
    ToStation: selDestinationCity?.ToCity,
    ToBranch: selDestinationBranch?.DestinationBranch,
    PaymentType: paymentType?.name,
    ReportView: selReportView?.name,
  }

  useEffect(() => {
    const SourceCity = [...new Set(dispatchResisterFilterData?.map((val) => ({ FromCityID: val.FromCityID, FromCity: val.FromCity })))]
    const SourceBranch = [
      ...new Set(
        dispatchResisterFilterData?.map((val) => ({
          FromBranchID: val.FromBranchID,
          FromBranch: val.FromBranch,
          FromCityID: val.FromCityID,
        }))
      ),
    ]
    const DestinationCity = [
      ...new Set(dispatchResisterFilterData?.map((val) => ({ ToCityID: val.ToCityID, ToCity: val.ToCity, FromCityID: val.FromCityID }))),
    ]
    const DestinationBranch = [
      ...new Set(
        dispatchResisterFilterData?.map((val) => ({
          DestinationBranchID: val.DestinationBranchID,
          DestinationBranch: val.DestinationBranch,
          ToCityID: val.ToCityID,
        }))
      ),
    ]
    const VehicleNoDropData = [
      ...new Set(dispatchResisterFilterData?.map((val) => ({ VehicleID: val.VehicleID, VehicleNo: val.VehicleNo }))),
    ]
    const selectedCity = removeDuplicatesFromArray(SourceCity, 'FromCityID')?.find((item) => item.FromCityID === loginData.intBranchCityID)
    const selectedBranch = removeDuplicatesFromArray(SourceBranch, 'FromBranchID')?.find(
      (item) => item.FromBranchID === loginData.intBranchID
    )
    setSourceCity([{ FromCityID: 0, FromCity: 'All' }, ...SourceCity])
    setSelSourceCity(selectedCity || { FromCityID: 0, FromCity: 'All' })
    setSelSourceBranch(selectedBranch || { FromBranchID: 0, FromBranch: 'All' })
    setSourceBranch([{ FromBranchID: 0, FromBranch: 'All' }, ...SourceBranch])
    setDestinationCity([{ ToCityID: 0, ToCity: 'All' }, ...DestinationCity])
    setDestinationBranch([{ DestinationBranchID: 0, DestinationBranch: 'All' }, ...DestinationBranch])
    const vehicleData = removeDuplicatesFromArray(VehicleNoDropData, 'VehicleID')
    setVehicleNoData(vehicleData)
    setSelVehicleNo(vehicleData?.[0])
  }, [dispatchResisterFilterData, selDispatchView])

  const callFilterAPI = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData.intCompanyID,
        DateFrom: moment(fromDate).format('YYYY-MM-DD'),
        DateTo: moment(toDate).format('YYYY-MM-DD'),
      }
      getDispatchRegisterReportFilter(obj)
      // const defaultCity = removeDuplicatesFromArray(sourceCity, 'FromCityID').filter(city => city.FromCityID === loginData.intBranchCityID);
      // console.log("loginData", loginData, defaultCity)
      // setSelSourceCity(defaultCity || defaultCity[0]);
      // setSelSourceCity({ FromCityID: 0, FromCity: 'All' })
      setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
      setSelDestinationCity({ ToCityID: 0, ToCity: 'All' })
      setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })
    }
  }

  const handleClick = () => {
    setShowReport(true)
    if (selReportView.id === 1) {
      const objMemoFirst = {
        intFromCityID: selSourceCity?.FromCityID,
        intFromBranchID: selSourceBranch?.FromBranchID,
        intToCityID: selDestinationCity?.ToCityID,
        intToBranchID: selDestinationBranch?.DestinationBranchID,
        intCompanyID: loginData.intCompanyID,
        dtFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtTo: moment(toDate).format('YYYY-MM-DD'),
        intUserID: loginData.intUserID,
        intAmountType: 2,
      }
      const objMemoSecond = {
        intFromCityID: selDestinationCity?.ToCityID,
        intFromBranchID: selDestinationBranch?.DestinationBranchID,
        intToCityID: selSourceCity?.FromCityID,
        intToBranchID: 0,
        intCompanyID: loginData.intCompanyID,
        dtFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtTo: moment(toDate).format('YYYY-MM-DD'),
        intUserID: loginData.intUserID,
        intAmountType: 0,
      }
      const objMemoThird = {
        intFromCityID: selDestinationCity?.ToCityID,
        intFromBranchID: selDestinationBranch?.DestinationBranchID,
        intToCityID: selSourceCity?.FromCityID,
        intToBranchID: 0,
        intCompanyID: loginData.intCompanyID,
        dtFrom: moment(fromDate).format('YYYY-MM-DD'),
        dtTo: moment(toDate).format('YYYY-MM-DD'),
        intUserID: loginData.intUserID,
        intAmountType: 2,
      }
      // GetDispatchRegistorMemoTableData(objMemoFirst)
      // GetDispatchRegistorMemoTableData(objMemoSecond)
      // GetDispatchRegistorMemoTableData(objMemoThird)
      GetDispatchRegistorMemoTableData(objMemoFirst).then((val) => {
        if (val.status === 'Success') {
          if (val?.Data?.Table?.length > 0) {
            const data = val?.Data?.Table?.map((item) => ({
              ...item,
              Total:
                (item.Freight || 0) +
                (item.F_S_Tax || 0) +
                (item.Cartage || 0) +
                (item.C_S_Tax || 0) +
                (item.Hamali || 0) +
                (item.OptHamali || 0) +
                (item.Total || 0),
            }))
            setTableDataForMemoFirst(data)
          } else {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
          }
        } else {
          //handle error
          // setShowReport(false)
          setTableDataForMemoFirst([])
          updateAlertError({ show: true, msg: val?.ErrMessage, nextId: '' })
        }
      })
      GetDispatchRegistorMemoTableData(objMemoSecond).then((val) => {
        if (val.status === 'Success') {
          if (val?.Data?.Table?.length > 0) {
            const data = val?.Data?.Table?.map((item) => ({
              ...item,
              Total:
                (item.Freight || 0) +
                (item.F_S_Tax || 0) +
                (item.Cartage || 0) +
                (item.C_S_Tax || 0) +
                (item.Hamali || 0) +
                (item.OptHamali || 0) +
                (item.Total || 0),
            }))
            setTableDataForMemoSecond(data)
          } else {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
          }
        } else {
          //handle error
          // setShowReport(false)
          setTableDataForMemoSecond([])
          updateAlertError({ show: true, msg: val?.ErrMessage, nextId: '' })
        }
      })
      GetDispatchRegistorMemoTableData(objMemoThird).then((val) => {
        if (val.status === 'Success') {
          if (val?.Data?.Table?.length > 0) {
            const data = val?.Data?.Table?.map((item) => ({
              ...item,
              Total:
                (item.Freight || 0) +
                (item.F_S_Tax || 0) +
                (item.Cartage || 0) +
                (item.C_S_Tax || 0) +
                (item.Hamali || 0) +
                (item.OptHamali || 0) +
                (item.Total || 0),
            }))
            setTableDataForMemoThird(data)
          } else {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: '' })
          }
        } else {
          //handle error
          // setShowReport(false)
          setTableDataForMemoThird([])
          updateAlertError({ show: true, msg: val?.ErrMessage, nextId: '' })
        }
      })
    } else if (selReportView.id === 0) {
      const obj = {
        FromCityID: selSourceCity?.FromCityID,
        FromBranchID: selSourceBranch?.FromBranchID,
        ToCityID: selDestinationCity?.ToCityID,
        ToBranchID: selDestinationBranch?.DestinationBranchID,
        CompanyID: loginData.intCompanyID,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(toDate).format('YYYY-MM-DD'),
        AmountType: paymentType?.id,
        // if (selDispatchView.id === 0) {
        //   VehicleNo:'GJ-01-LA-1314',
        // }
      }
      if (selDispatchView.id === 1) {
        obj.VehicleNo = selVehicleNo?.VehicleNo
        getDispatchRegisterReportVehicleWiseTableData(obj)
      } else {
        getDispatchRegisterReportTableData(obj)
      }
    } else {
      const data = {
        FromCityID: selSourceCity?.FromCityID || 0,
        FromBranchID: selSourceBranch?.FromBranchID || 0,
        ToCityID: selDestinationCity?.ToCityID || 0,
        ToBranchID: selDestinationBranch?.DestinationBranchID || 0,
        ToBranchID: selDestinationBranch?.DestinationBranchID || 0,
        CompanyID: intCompanyID,
        DateFrom: moment(fromDate).format('YYYY-MM-DD'),
        DateTo: moment(toDate).format('YYYY-MM-DD'),
        AmountType: 0,
      }
      fetchMemoSummary(data)
    }
  }

  const selectedSourceCity = (obj) => {
    const destCity = dispatchResisterFilterData?.filter((val) => val.ToCityID !== obj?.FromCityID)
    setDestinationCity([{ ToCityID: 0, ToCity: 'All' }, ...destCity])
    // setShowReport(false)
    setSelSourceCity(obj)
    const branchData = removeDuplicatesFromArray(dispatchResisterFilterData, 'FromBranchID').filter(
      (val) => val.FromCityID === obj?.FromCityID || obj?.FromCityID === 0 || val.FromBranchID === 0
    )
    setSourceBranch([{ FromBranchID: 0, FromBranch: 'All' }, ...branchData])
    setSelSourceBranch({ FromBranchID: 0, FromBranch: 'All' })
  }
  const selectedDestinationCity = (obj) => {
    // setShowReport(false)
    setSelDestinationCity(obj)
    const destBranchData = dispatchResisterFilterData?.filter((val) => val.ToCityID === obj?.ToCityID || obj?.ToCityID === 0 || val.DestinationBranchID === 0)
    setDestinationBranch([{ DestinationBranchID: 0, DestinationBranch: 'All' }, ...destBranchData])
    setSelDestinationBranch({ DestinationBranchID: 0, DestinationBranch: 'All' })
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex} style={{ background: '#fff', borderBottom: '1px solid #ccc', paddingBottom: '10px' }}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id="selectCompnay"
              prevId={'generateDiv'}
              nextId={'ArrowForwardIosIcon1'}
              label={'Company Name'}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              //   onSelect={(val) => setSelCompany(val)}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon1"
            sx={sx.itemsx}
            className="disabled-wrapper"
            variant="contained"
            disabled={true}
            // onKeyDown={(e) => handlekeyDown(e, 'selectCompnay', 'fromDate', 'ArrowForwardIosIcon1Btn')}
            style={{ ...sx.novp, display: 'flex', justifyContent: 'center', width: '4%', backgroundColor: '#CCC' }}
          >
            <ArrowForwardIosIcon id="ArrowForwardIosIcon1Btn" />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              label={`Dispatch From Date`}
              id="fromDate"
              nextId={'toDate'}
              dateChange={(date) => {
                setFromDate(date)
                // focusElemnt('toDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'to_dispatch_date'}
              label={'Dispatch To Date'}
              id="toDate"
              nextId={'ArrowForwardIosIcon2'}
              prevId={'fromDate'}
              dateChange={(date) => {
                setToDate(date)
                // focusElemnt('ArrowForwardIosIcon2')
              }}
              width="100%"
            />
          </Item>
          <Item
            tabIndex={0}
            id="ArrowForwardIosIcon2"
            sx={sx.itemsx}
            className="enable-wrapper"
            variant="contained"
            // onKeyDown={(e) => handlekeyDown(e, 'fromDate', 'dispatchByBranch', 'ArrowForwardIosIconBtn', 'go')}
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '4%',
              color: 'white',
              backgroundColor: '#fe5200',
              borderRadius: '4px',
            }}
          >
            <ArrowForwardIosIcon id="ArrowForwardIosIconBtn" onClick={callFilterAPI} />
            {/* <ArrowForwardIosIcon onClick={callFilterAPi} id="ArrowForwardIosIconBtn" /> */}
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From City'}
              id="dispatchByBranch"
              nextId={'destination'}
              prevId={'ArrowForwardIosIcon2'}
              data={removeDuplicatesFromArray(sourceCity, 'FromCityID')}
              dataKey={`FromCity`}
              idKey={`FromCityID`}
              //disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport==0}
              defaultvalue={selSourceCity?.FromCity || ''}
              //   value={selFromBranch?.name || ''}
              isObjArr={true}
              onSelect={(obj) => selectedSourceCity(obj)}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch From Branch'}
              id="destination"
              nextId={'destinationBranch'}
              prevId={'dispatchByBranch'}
              data={removeDuplicatesFromArray(sourceBranch, 'FromBranchID') || []}
              dataKey={`FromBranch`}
              idKey={`FromBranchID`}
              defaultvalue={selSourceBranch?.FromBranch || selSourceBranch}
              //   value={selDestCity?.name || ''}
              onSelect={(val) => {
                setSelSourceBranch(val)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={'Dispatch View'}
              id="destinationBranch"
              nextId={'vehicleList'}
              prevId={'destination'}
              data={dispatchView}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(val) => {
                setShowReport(false)
                setSelDispatchView(val)
              }}
              defaultvalue={selDispatchView?.name || selDispatchView}
              //   value={selBranch?.name || ''}
              width="100%"
              // minWidth="230px"
            />
          </Item>
          {selDispatchView.id === 0 ? (
            <>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'To City'}
                  id="toStation"
                  defaultvalue={selDestinationCity?.ToCity || ''}
                  //   value={selVehicle?.name || ''}
                  data={removeDuplicatesFromArray(destinationCity, 'ToCityID') || []}
                  dataKey={`ToCity`}
                  idKey={`ToCityID`}
                  onSelect={(val) => {
                    selectedDestinationCity(val)
                  }}
                  nextId={'paymentBookingType'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'To Branch'}
                  id=""
                  defaultvalue={selDestinationBranch?.DestinationBranch || ''}
                  //   value={selVehicle?.name || ''}
                  data={removeDuplicatesFromArray(destinationBranch, 'DestinationBranchID') || []}
                  dataKey={`DestinationBranch`}
                  idKey={`DestinationBranchID`}
                  onSelect={(val) => {
                    setSelDestinationBranch(val)
                  }}
                  nextId={'paymentBookingType'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'Payment Type'}
                  // data={paymentModesWithAll || []}
                  data={(paymentModesWithAll || []).map((item) => {
                    if (UseToPayAsCOD === 1) {
                      if (item.id === 2) {
                        return { ...item, name: 'COD' };
                      }
                      if (item.id === 7) {
                        return { ...item, name: 'COD Manual' };
                      }
                      if (item.id === 9) {
                        return { ...item, name: 'COD DDDV' };
                      }
                      if (item.id === 4) {
                        return null;
                      }
                    }
                    return item;
                  }).filter(Boolean)
                  }
                  id="paymentType"
                  nextId={'TransactionType'}
                  prevId={'destinationBranch'}
                  defaultvalue={paymentType?.name || ''}
                  width="100%"
                  searchPlaceholder={`Search By Payment Type`}
                  tabIndex="2"
                  dataKey={`name`}
                  idKey={`id`}
                  onSelect={(val) => {
                    setPaymentType(val)
                  }}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'Report View'}
                  id="vehicleList"
                  defaultvalue={selReportView?.name || selReportView}
                  // value={selVehicle?.name || ''}
                  data={reportViewList || []}
                  dataKey={`name`}
                  idKey={`id`}
                  onSelect={(val) => {
                    setShowReport(false)
                    setSelReportView(val)
                  }}
                  nextId={'paymentBookingType'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
            </>
          ) : (
            <>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'Select Vehicle'}
                  id="akash"
                  defaultvalue={selVehicleNo?.VehicleNo || ''}
                  value={selVehicleNo?.VehicleNo || ''}
                  data={vehicleNoData || []}
                  dataKey={`VehicleNo`}
                  idKey={`VehicleID`}
                  onSelect={(val) => {
                    setSelVehicleNo(val)
                  }}
                  nextId={'paymentBookingType'}
                  prevId={'destinationBranch'}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  label={'Payment Type'}
                  data={paymentModesWithAll || []}
                  id="paymentType"
                  nextId={'TransactionType'}
                  prevId={'destinationBranch'}
                  defaultvalue={paymentType?.name || ''}
                  width="100%"
                  searchPlaceholder={`Search By Payment Type`}
                  tabIndex="2"
                  dataKey={`name`}
                  idKey={`id`}
                  onSelect={(val) => {
                    setPaymentType(val)
                  }}
                />
              </Item>
            </>
          )}

          <Item
            id="generateDiv"
            tabIndex={0}
            sx={sx.itemsx}
            // onKeyDown={(e) => navigation3(e, showReport ? "DispatchPrintBtn" : 'fromDate', 'reportOption', () => handleClick1())}
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}
              prevId={'reportOption'}
              id1={'generateBtn'}
              // id="generateBtn"
              nextId={'fromDate'}
              hideToggle={true}
              onClick1={handleClick}
              //   onClick2={handleClick2}
              disabled={false}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, display: 'none' }}>
            <RefreshSvg />
          </Item>
        </Box>
      </Item>

      {showReport ? (
        selDispatchView.id === 0 && selReportView.id === 0 ? (
          <StationWiseDefaultView UseToPayAsCOD={UseToPayAsCOD} dispatchResisterTableData={dispatchResisterTableData} HeaderData={HeaderData} />
        ) : selDispatchView.id === 0 && selReportView.id === 1 ? (
          <StationWiseMemoView
            tableDataForMemoFirst={tableDataForMemoFirst}
            tableDataForMemoSecond={tableDataForMemoSecond}
            tableDataForMemoThird={tableDataForMemoThird}
            HeaderData={HeaderData}
          />
        ) : selDispatchView.id === 1 ? (
          <VehicleWiseDefaultView UseToPayAsCOD={UseToPayAsCOD} dispatchResisterTableData={dispatchResisterTableVehicleWiseData} HeaderData={HeaderData} />
        ) : (
          ''
        )
      ) : null}
      {showReport && selReportView.id === 2 ? (
        <MemoSummary UseToPayAsCOD={UseToPayAsCOD}
          tableDataForMemoFirst={tableDataForMemoFirst}
          tableDataForMemoSecond={tableDataForMemoSecond}
          tableDataForMemoThird={tableDataForMemoThird}
          HeaderData={HeaderData}
        />
      ) : (
        ''
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  getDispatchRegisterReportFilter,
  getDispatchRegisterReportTableData,
  GetDispatchRegistorMemoTableData,
  getDispatchRegisterReportVehicleWiseTableData,
}
export default connect(mapStateToProps, mapDispatchToProps)(DispatchRegister)
